(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const showInStockCollection = () => {
      if (!document.querySelector('[data-collection-in-stock]')) return;
      const url = new URL(window.location.href);
      const values = url.searchParams.getAll('filter.v.availability');
      if (values.length === 1 && values[0] === '1') return;
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      window.location.replace(url.href);
    };
    showInStockCollection();
    document.addEventListener('shopify:section:load', showInStockCollection);
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter-toggle]');
      if (!button) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      panel.classList.toggle('is-open', expanded);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const sectionsWithin = (container) => {
      const sections = Array.from(container.querySelectorAll('[data-recommendations-url]'));
      if (container.matches?.('[data-recommendations-url]')) sections.unshift(container);
      return sections;
    };
    const initialize = (container = document) => {
      sectionsWithin(container).forEach((section) => {
        if (instances.has(section)) return;
        const controller = new AbortController();
        const instance = { controller, observer: null, started: false };
        instances.set(section, instance);
        const load = async () => {
          if (instance.started || !section.isConnected) return;
          instance.started = true;
          instance.observer?.disconnect();
          try {
            const response = await fetch(section.dataset.recommendationsUrl, { signal: controller.signal });
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const recommendations = html.querySelector('[data-recommendations-url]');
            if (!section.isConnected || controller.signal.aborted) return;
            if (recommendations?.innerHTML.trim()) {
              section.innerHTML = recommendations.innerHTML;
              section.dispatchEvent(new CustomEvent('hooligan:content:loaded', { bubbles: true }));
            }
          } catch (error) {}
        };
        if (section.querySelector('.product-card')) {
          section.dispatchEvent(new CustomEvent('hooligan:content:loaded', { bubbles: true }));
        } else if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
          instance.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) load();
          }, { rootMargin: '0px 0px 300px 0px' });
          instance.observer.observe(section);
        } else {
          load();
        }
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      sectionsWithin(event.target).forEach((section) => {
        const instance = instances.get(section);
        instance?.observer?.disconnect();
        instance?.controller.abort();
        instances.delete(section);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const sectionsWithin = (container) => {
      const sections = Array.from(container.querySelectorAll('[data-recently-viewed]'));
      if (container.matches?.('[data-recently-viewed]')) sections.unshift(container);
      return sections;
    };
    const initialize = (container = document) => {
      sectionsWithin(container).forEach(async (section) => {
        if (instances.has(section)) return;
        const controller = new AbortController();
        instances.set(section, controller);
        const storageKey = 'hooligan-recently-viewed';
        const currentHandle = section.dataset.currentProduct;
        const limit = Math.min(8, Math.max(1, Number(section.dataset.productsToShow) || 4));
        let handles = [];
        try {
          const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
          if (Array.isArray(stored)) handles = [...new Set(stored.filter((handle) => typeof handle === 'string' && handle.trim()))];
        } catch (error) {}
        const displayHandles = handles.filter((handle) => handle !== currentHandle).slice(0, limit);
        if (currentHandle) {
          const updatedHandles = [currentHandle, ...handles.filter((handle) => handle !== currentHandle)].slice(0, 12);
          try { localStorage.setItem(storageKey, JSON.stringify(updatedHandles)); } catch (error) {}
        }
        const grid = section.querySelector('[data-recently-viewed-grid]');
        if (!displayHandles.length || !grid) return;
        const root = window.Shopify?.routes?.root || '/';
        const responses = await Promise.all(displayHandles.map(async (handle) => {
          try {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=recently-viewed-card`, { signal: controller.signal });
            return response.ok ? await response.text() : '';
          } catch (error) { return ''; }
        }));
        if (!section.isConnected || controller.signal.aborted) return;
        const cards = responses.map((text) => new DOMParser().parseFromString(text, 'text/html').querySelector('.product-card')).filter(Boolean);
        grid.replaceChildren(...cards);
        section.hidden = cards.length === 0;
        if (cards.length) section.dispatchEvent(new CustomEvent('hooligan:content:loaded', { bubbles: true }));
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      sectionsWithin(event.target).forEach((section) => {
        instances.get(section)?.abort();
        instances.delete(section);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
